// @ts-nocheck
import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Autocomplete, TextField } from '@mui/material';

import { ReactComponent as DropdownArrow } from '../../../../assets/images/DropdownArrow.svg';
import { useConstantAttributeListQuery } from '../../../../queries/useConfigQueries';
import { getErrorHelperText } from '../../../../utils/Utils';
import { EMPTY_ARRAY } from '../../../../const/CommonConst';

const getParameterTableOptionLabel = (option) => option?.name;
const isOptionEqualToValue = (option, value) =>
  String(option?.id) === String(value?.id);

const ParameterTableFieldComponent = ({
  label,
  titleLabel,
  value,
  onChange,
  attribute,
  entityDetailsFormikForm,
  required = false,
}) => {
  const { data: parameterTableList = EMPTY_ARRAY } =
    useConstantAttributeListQuery({
      params: { minimal: true },
    });

  const filteredList = useMemo(() => {
    return parameterTableList?.filter(
      (item) => item?.data_type === 'DataFrame'
    );
  }, [parameterTableList]);

  const selectedOption = useMemo(() => {
    return (
      filteredList.find((option) => String(option?.id) === String(value?.id)) ||
      null
    );
  }, [filteredList, value]);

  const handleChange = useCallback(
    (_event, newValue) => {
      if (newValue) {
        onChange({
          id: newValue?.id,
          name: newValue?.name,
        });
      } else {
        onChange(null);
      }
    },
    [onChange]
  );

  const renderInput = useCallback(
    (params) => (
      <TextField
        {...params}
        label={label}
        title={titleLabel}
        required={required}
        placeholder="Select parameter table"
        InputProps={{
          ...params.InputProps,
          placeholder: 'Select parameter table',
        }}
        InputLabelProps={{
          shrink: true,
        }}
        error={Boolean(
          getErrorHelperText(
            entityDetailsFormikForm?.errors?.[attribute?.id],
            entityDetailsFormikForm?.touched?.[attribute?.id]
          )
        )}
        helperText={getErrorHelperText(
          entityDetailsFormikForm?.errors?.[attribute?.id],
          entityDetailsFormikForm?.touched?.[attribute?.id]
        )}
      />
    ),
    [attribute?.id, entityDetailsFormikForm, label, required, titleLabel]
  );

  return (
    <Autocomplete
      value={selectedOption}
      options={filteredList}
      onChange={handleChange}
      noOptionsText="No parameter tables present."
      popupIcon={<DropdownArrow />}
      getOptionLabel={getParameterTableOptionLabel}
      isOptionEqualToValue={isOptionEqualToValue}
      renderInput={renderInput}
    />
  );
};

ParameterTableFieldComponent.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  titleLabel: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.shape({}),
  ]),
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
  attribute: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
  entityDetailsFormikForm: PropTypes.shape({
    setFieldTouched: PropTypes.func,
    errors: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string])),
    touched: PropTypes.objectOf(PropTypes.bool),
  }),
};

export default ParameterTableFieldComponent;
